export const flatpickrItalian = {
	weekdays: {
		shorthand: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
		longhand: [
			"Domenica",
			"Lunedì",
			"Martedì",
			"Mercoledì",
			"Giovedì",
			"Venerdì",
			"Sabato",
		],
	},
	months: {
		shorthand: [
			"Gen",
			"Feb",
			"Mar",
			"Apr",
			"Mag",
			"Giu",
			"Lug",
			"Ago",
			"Set",
			"Ott",
			"Nov",
			"Dic",
		],
		longhand: [
			"Gennaio",
			"Febbraio",
			"Marzo",
			"Aprile",
			"Maggio",
			"Giugno",
			"Luglio",
			"Agosto",
			"Settembre",
			"Ottobre",
			"Novembre",
			"Dicembre",
		],
	},
	firstDayOfWeek: 1,
	ordinal: function () {
		return "°";
	},
	rangeSeparator: " al ",
	weekAbbreviation: "Se",
	scrollTitle: "Scorri per aumentare",
	toggleTitle: "Clicca per cambiare",
	time_24hr: true,
};
